<div class="display-flex align-items-center bg-brand custom-header">
  <span class="text-color-white font-weight-bold header-label">{{ label }}</span>
</div>
